export enum ItemsList {
  four = '4',
  eight = '8',
  sixteen = '16',
  all = 'all',
}
